import { createVanIconComponent } from "./van"

const LikeOutlined = createVanIconComponent("like-o")
export default LikeOutlined
